import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ArtBrandedDesktopPopup, ArtBrandedMobilePopup, } from '../ArtBrandedPopup';
import Button from '../Button';
import { MobileContext } from '../Context';
import { ThemeOptions } from '../publicSession/types';
import { useFlag } from '../redux/flags/hooks/useFlag';
import s from './VerificationSuccessfulPopup.scss';
var POPUP_ARTWORKS = [
    {
        imageSrc: 'https://st.deviantart.net/eclipse/popups/artworks/ellysiumn-1.png',
        username: 'ellysiumn',
    },
    {
        imageSrc: 'https://st.deviantart.net/eclipse/popups/artworks/ellysiumn-2.png',
        username: 'ellysiumn',
    },
];
var getRandomArtWork = function () {
    return POPUP_ARTWORKS[Math.floor(Math.random() * POPUP_ARTWORKS.length)];
};
var VerificationSuccessfulPopup = function () {
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isPhaseTwoUpdate = useFlag('verification_popup_updates_phase2');
    var _a = getRandomArtWork(), imageSrc = _a.imageSrc, username = _a.username;
    var onClose = function () { return window.location.assign(Url.browseHomeLink()); };
    if (isMobile && isPhaseTwoUpdate) {
        return (React.createElement(ArtBrandedMobilePopup, { artImageSrc: 'https://st.deviantart.net/eclipse/popups/artworks/ellysiumn-1.png', artAuthorUsername: 'ellysiumn', onClose: onClose, popupProps: { isOpen: true, forceTheme: ThemeOptions.DARK } },
            React.createElement("div", { className: s['title'] }, t('verificationSuccessful.title')),
            React.createElement("div", { className: s['text'] }, t('verificationSuccessful.textOne')),
            React.createElement("div", { className: s['text'] }, t('verificationSuccessful.textTwo')),
            React.createElement(Button, { href: Url.browseHomeLink(), view: "b1-1", className: s['browse-button'], height: 'large' }, t('verificationSuccessful.browse'))));
    }
    else {
        return (React.createElement(ArtBrandedDesktopPopup, { artImageSrc: imageSrc, artAuthorUsername: username, title: t('verificationSuccessful.title'), tagline: t('verificationSuccessful.tagline'), titleClassName: s['title'], contentClassName: s['content'], popupProps: { isOpen: true }, onClose: onClose },
            React.createElement("div", { className: s['text'] }, t('verificationSuccessful.textOne')),
            React.createElement("div", { className: s['text'] }, t('verificationSuccessful.textTwo')),
            React.createElement(Button, { href: Url.browseHomeLink(), view: "b1-1", className: s['browse-button'], fullWidth: false }, t('verificationSuccessful.browse'))));
    }
};
VerificationSuccessfulPopup.displayName = 'VerificationSuccessfulPopup';
export default VerificationSuccessfulPopup;
//# sourceMappingURL=VerificationSuccessfulPopup.js.map